import scribdAuthorize from '../../scribd/scribd_oauth.js';

function SSComments(slideshare_object){
  if (typeof slideshare_object === "undefined"){
    return;
  }
  this.setup_comments_interaction(slideshare_object);
}
  SSComments.prototype.setup_comments_interaction = function(ss) {
    var $notesList = $('#notesList');
    var $emptyNote = $('#empty-note');
    var $commentInput = ss.svComments.find('.j-post-comment-input');
    var notes_li = $notesList.find('li').hide();
    var note = notes_li[0];
    ss.notes = {
      onload: function(n) {
        notes_li.hide();
        note = notes_li[n-1];
        if (note) {
          $emptyNote.hide();
          note = $(note).show();
        } else {
          $emptyNote.show();
        }
      }
    };
    var $moreBtn = ss.svComments.find('.j-more-comments');

    $.extend(ss.comments, {
      slide_number: 1,

      onload: function(n) {
        ss.comments.slide_number = n;
      },
      get_secret_key: function() {

        // Secret URLs will always have a URL scheme of /secret/[secret_key]
        if(/\/secret\//.test(window.location.href)) {
          return window.location.href.match(/\/secret\/(.*)/)[1];
        }
        return '';
      },
      reply_to_comment: function(commentId, form) {
        var commentOf = $('#' + commentId).find('.j-username').html();
        var $commentsContainer = $commentInput.closest('.j-comment-post');
        var topOfCommentsContainer = $commentsContainer.offset().top -
          $('#main-nav').height() + 50;
        $.scrollTo(topOfCommentsContainer, 500);
        $commentInput.focus().val('@' + commentOf + ' ');
      },
      sanitize_action_links: function() {
        // removing delete and block links according to permissions
        $('#commentsList')
          .find('.j-action-delete, .j-action-block')
          .remove();
      },
      save_comments: function() {
        var commentFormContent = $commentInput.val();
        if (commentFormContent.length > 0){
          window.cookie('comments',commentFormContent, {path : window.location.pathname});
        }
        else{
          window.cookie('comments',null, {path : window.location.pathname});
        }
      },

      delete_saved_comments: function() {
        if (window.cookie('comments') !== null) {
          window.cookie('comments',null,{path: window.location.pathname});
        }
      },
      decorate_comment_user: function(comment, user) {
        // log("decorate_comment_user", comment, user);
        $(".j-author-photo img", comment).each(function(index, ele) {
          ele.src = user.photo_url;
          ele.alt = user.login;
        });
        $(".j-author-photo .j-username", comment).each(function(index, ele) {
          ele.href = '/' + user.login;
          ele.title = user.login;
        });
        $(".j-author-photo", comment).each(function(index, ele) {
          ele.href = '/' + user.login;
          ele.title = user.user_description;
        });
        $(".j-author-photo .j-username", comment).text(user.name || user.login);
      },
      per_page: 5,
      current_page: 1,
      currently_shown: null,
      setup_scrolling_on_reply: function() {
        ss.svComments.on('click', '.j-reply', function(e) {
          e.preventDefault();
          ss.comments.reply_to_comment($(this).closest('li.comment').attr('id'),
          ss.svCommentsForm);
        });
      },
      show_page: function(page, per_page, total_comments) {
        // need to ajaxify delete links here so that dynamically added comments are also hooked up
        per_page = per_page || this.per_page; // optionally override
        total_comments = total_comments || $('.comment', ss.svComments).length;
        var total_pages = (total_comments / per_page);
        var start_index = (page - 1) * per_page;
        if (start_index > total_comments-1) { start_index = total_comments-1; }
        var end_index = start_index + per_page;
        if (end_index > total_comments-1) { end_index = total_comments; }

        this.currently_shown = $('.comment', ss.svCommentsul).slice(start_index, end_index).show();
        this.current_page = page;

        if (total_pages > 1) {
          $moreBtn.show();
        } else {
          $moreBtn.hide();
        }

        if (this.current_page >= total_pages) {
          $moreBtn.closest('.more-container').hide();
        }

        ss.comments.setup_scrolling_on_reply();
        $(".thumbnailGrid").trigger("adjustHeight");
      }
    });

    $('.alertMessage a').click(function(e) {
      e.preventDefault();
    });

    $('#login-provider-slideshare').bind('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      ss.comments.save_comments();
      scribdAuthorize({ from_source: window.location.pathname, slideshow_id: ss.slideshow.id });
    });

    $moreBtn.click(function(e) {
      e.preventDefault();
      if (ss.comments.ajaxurl && ss.comments.total_count > ss.comments.per_page) {
        var loading = $(ss.loading_html);
        loading.appendTo($moreBtn.parent());
        $moreBtn.hide();
        var key = ss.comments.get_secret_key();

        $.getJSON(ss.comments.ajaxurl, { 'key': key }, function(json) {
          $.each(json, function(index, data) {
            if (index >= ss.comments.per_page) {
              var comment = $('#commentsTemplate').clone().hide();
              comment.attr('itemprop', data.user_schema_type);
              if (data.user_occupation === ''){
                comment.children().remove('.j-commenter-role');
              } else {
                $('.j-commenter-role',comment).text(', ' + data.user_occupation);
              }
              if (data.user_organization === ''){
                comment.children().remove('.j-commenter-org');
              } else {
                $('.j-commenter-org',comment).text(' at ' + data.user_organization);
              }
              ss.comments.decorate_comment_user(comment, data);
              $(".commentTimestamp", comment).text(data.created_at + ' ago');
              $(".commentText", comment).html(data.body);
              comment[0].id = 'comment-' + data.comment_id;
              $(comment[0]).find('#confirmDialog').attr('id',
                                 'confirmDialog-'+data.comment_id);

              comment.addClass('author-' + data.user_id).addClass('comment');
              comment.appendTo(ss.svCommentsul);
            }
          });
          ss.comments.sanitize_action_links();
          if (ss.setup_owner_interaction) { ss.setup_owner_interaction(); }
          $('.j-loading', $moreBtn.parent()).remove();
          ss.comments.show_page(ss.comments.current_page+1);
        });
        } else {
        ss.comments.show_page(ss.comments.current_page+1);
        }
        ss.comments.ajaxurl = null;
      });
    ss.svCommentsForm.jssubmit(function(event) {
      var commentInputVal = $('#postComment .j-post-comment-input').val();
      if (!!commentInputVal) {
        ss.comments.delete_saved_comments();
        ss.comments.post_comment(event.target);
        $('.comment .action-block').first().hide();
      }
    });

    ss.comments.show_page(ss.comments.current_page, ss.comments.per_page, ss.comments.total_count);
    ss.svComments.show();
    ss.svCommentsForm.show();
    if($.inArray(getUrlVar('utm_source'), ['commentback']) > -1){
      $.scrollTo(ss.svCommentsForm, {offset: -90});
    }
    $('.tabs li a', ss.svComments).showhide('.svComments .comments-tab, .svComments .notes-tab');
    window.loadDataForSlide(slideshare_object.startSlide);
  };

// swf
window.loadDataForSlide = function(n) {
  if(slideshare_object.topRightAd){
    slideshare_object.topRightAd.trigger("refreshAd");
  }

  if (slideshare_object.comments.onload) {
    slideshare_object.comments.onload(n);
    slideshare_object.notes.onload(n);
  } else {
    setTimeout(function() { window.loadDataForSlide(n); }, 100);
  }
};

window.SSComments = SSComments;
export default SSComments
